// extracted by mini-css-extract-plugin
module.exports = {"Container":"Location_Container__1Xf_t","Loader":"Location_Loader__1dxaV"};